import { motion } from 'framer-motion';

const skills = [
  { name: 'React Native', level: 95 },
  { name: 'React (Next.js)', level: 90 },
  { name: 'Flutter', level: 85 },
  { name: 'Node.js', level: 85 },
  { name: 'Firebase', level: 80 },
  { name: 'MySQL', level: 75 },
  { name: 'TypeScript', level: 90 },
  { name: 'JavaScript, HTML & CSS', level: 92 },
];

const About = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
          About <span className="bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">Me</span>
        </h2>
        
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-2xl font-semibold mb-4">Who Am I?</h3>
            <p className="text-gray-300 mb-6 leading-relaxed">
              I'm a dedicated React Native Developer with 3 years of professional experience at Truworth Health Technologies 
              in Jaipur. I specialize in creating cross-platform mobile applications and have a passion for building 
              efficient, scalable, and user-friendly healthcare technology solutions.
            </p>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Currently, I maintain "The Wellness Corner" application and develop reusable NPM packages and modules 
              that work seamlessly across both mobile and web platforms. My expertise lies in React Native development, 
              JavaScript/TypeScript, and creating maintainable code architectures for healthcare applications.
            </p>
            <p className="text-gray-300 leading-relaxed">
              I enjoy solving complex technical challenges, optimizing app performance, and contributing to the healthcare 
              technology ecosystem. My goal is to create digital solutions that make healthcare more accessible and 
              user-friendly for everyone.
            </p>
          </div>
          
          <div>
            <h3 className="text-2xl font-semibold mb-6">My Skills</h3>
            <div className="space-y-4">
              {skills.map((skill, index) => (
                <div key={skill.name} className="space-y-1">
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-300">{skill.name}</span>
                    <span className="text-blue-400">{skill.level}%</span>
                  </div>
                  <div className="h-2 bg-gray-700 rounded-full overflow-hidden">
                    <motion.div
                      initial={{ width: 0 }}
                      whileInView={{ width: `${skill.level}%` }}
                      viewport={{ once: true }}
                      transition={{ duration: 1, delay: index * 0.1 }}
                      className="h-full bg-gradient-to-r from-blue-500 to-purple-600 rounded-full"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        
        <div className="mt-16 grid md:grid-cols-3 gap-8">
          <motion.div
            whileHover={{ y: -5 }}
            className="bg-gray-800/50 p-6 rounded-xl border border-gray-700/50 hover:border-blue-500/30 transition-all"
          >
            <div className="w-12 h-12 bg-blue-500/10 rounded-lg flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M12 16h.01M16 12h.01M12 12h.01M8 12h.01" />
              </svg>
            </div>
            <h4 className="text-xl font-semibold mb-2">Web Development</h4>
            <p className="text-gray-400">Building responsive and interactive web applications with modern frameworks and best practices.</p>
          </motion.div>
          
          <motion.div
            whileHover={{ y: -5 }}
            className="bg-gray-800/50 p-6 rounded-xl border border-gray-700/50 hover:border-purple-500/30 transition-all"
          >
            <div className="w-12 h-12 bg-purple-500/10 rounded-lg flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
            </div>
            <h4 className="text-xl font-semibold mb-2">Clean Code</h4>
            <p className="text-gray-400">Writing maintainable, efficient, and well-documented code following best practices.</p>
          </motion.div>
          
          <motion.div
            whileHover={{ y: -5 }}
            className="bg-gray-800/50 p-6 rounded-xl border border-gray-700/50 hover:border-blue-500/30 transition-all"
          >
            <div className="w-12 h-12 bg-blue-500/10 rounded-lg flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
            </div>
            <h4 className="text-xl font-semibold mb-2">Responsive Design</h4>
            <p className="text-gray-400">Creating websites that work seamlessly across all devices and screen sizes.</p>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default About;
